import { render, staticRenderFns } from "./ChatDisclaimerDialog.vue?vue&type=template&id=3e2c110a&scoped=true"
import script from "./ChatDisclaimerDialog.vue?vue&type=script&lang=js"
export * from "./ChatDisclaimerDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatDisclaimerDialog.vue?vue&type=style&index=0&id=3e2c110a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2c110a",
  null
  
)

export default component.exports